import { useState, useEffect } from "react";

export default function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState("hat"); // hat → shrink → logo → out

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("shrink"), 1000);
    const t2 = setTimeout(() => setPhase("logo"), 1800);
    const t3 = setTimeout(() => setPhase("out"), 3400);
    const t4 = setTimeout(() => onComplete?.(), 4000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); };
  }, [onComplete]);

  return (
    <div className={`fixed inset-0 z-[200] bg-white flex items-center justify-center transition-opacity duration-500 ${phase === "out" ? "opacity-0" : "opacity-100"}`}>
      <div className="relative flex flex-col items-center">
        
        {/* Chef Hat SVG - black silhouette on white */}
        <div className={`transition-all ease-in-out ${
          phase === "hat" ? "scale-100 opacity-100 duration-700" :
          phase === "shrink" ? "scale-[0.35] opacity-100 -translate-y-6 duration-700" :
          "scale-[0.35] opacity-100 -translate-y-6 duration-300"
        }`}>
          <svg width="140" height="140" viewBox="0 0 140 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Toque / Crown - 3 lobes */}
            <ellipse cx="70" cy="35" rx="22" ry="26" fill="#18181b" />
            <ellipse cx="42" cy="40" rx="20" ry="22" fill="#18181b" />
            <ellipse cx="98" cy="40" rx="20" ry="22" fill="#18181b" />
            {/* Fill gaps between lobes */}
            <rect x="35" y="30" width="70" height="30" fill="#18181b" />
            {/* Smooth top */}
            <ellipse cx="55" cy="30" rx="16" ry="20" fill="#18181b" />
            <ellipse cx="85" cy="30" rx="16" ry="20" fill="#18181b" />
            {/* Band / Base */}
            <rect x="30" y="60" width="80" height="24" rx="2" fill="#18181b" />
            {/* Subtle band line */}
            <rect x="30" y="66" width="80" height="2.5" rx="1" fill="white" opacity="0.12" />
          </svg>
        </div>

        {/* Text Logo - fades in as hat shrinks */}
        <div className={`transition-all ease-out ${
          phase === "hat" ? "opacity-0 translate-y-8 scale-95 duration-300" :
          phase === "shrink" ? "opacity-0 translate-y-4 scale-95 duration-300" :
          "opacity-100 translate-y-0 scale-100 duration-700"
        }`} style={{ marginTop: phase === "hat" ? 0 : "-8px" }}>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-zinc-950 text-center">
            SOP & RAFT
          </h1>
          <p className="text-[10px] sm:text-xs tracking-[0.2em] uppercase text-zinc-400 font-semibold text-center mt-1.5">
            Cozinha Inteligente
          </p>
        </div>
      </div>
    </div>
  );
}
